<template>
  <div class="home-page-box">
    <!-- 顶部 -->
    <homeHead :isRouterIndex="'1'"></homeHead>

    <div class="home-page-content">

      <!-- 文章 -->
      <div class="home-app">
        <div class="home-card">

          <div class="home-card__content border-radius__16  overflow-auto backgroundTr">
            <div class="home-card__content--wrapper " style="padding: 10px 0px;">
              <div class="app-list__content ">
                <div class="article-padding-box">
                  <div class="details-padding" v-if="articleContent != ''">
                    <div class="detail-title">
                      {{ articleContent.title }}
                    </div>
                    <div class="detail-timess">
                      <div class="times">
                        发布时间：{{ articleContent.releaseTime | analyseTime('2') }}
                      </div>
                      <!-- <div class="numbers">
                      阅读数：{{ articleContent.recordNum }}
                    </div> -->
                    </div>

                    <div class="articleContent" v-html="articleContent.content">

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <homeFooter></homeFooter>
  </div>
</template>
<script>
import homeHead from '../../component/homeHead.vue'
import homeFooter from '../../component/homeFooter.vue'

import homeSearch from '../../component/homeSearch.vue'
import { getArticleInfoById } from '../../../../api/api.p'
import { dateFormat } from '../../../../libs/util'
import { analyseTime } from '../../../../components/filter'
import axios from 'axios';

export default {
  props: {},
  data () {
    return {
      articleId: '',
      articleContent: '',
    }
  },
  filters: {

  },
  components: {
    homeHead,
    homeFooter,
    homeSearch,
  },
  created () {
  },
  mounted () {

    if (this.$route.query.articleId) {
      this.articleId = this.$route.query.articleId;
      this.getArticleInfoById()

    }



  },
  methods: {
    addClassToImages (htmlString) {
      return htmlString.replace(/<img(.*?)>/g, '$1 style="height: 100px;">');
    },
    async getArticleInfoById () {

      let params = {
        articleId: this.articleId
      }
      const res = await getArticleInfoById(params)
      if (res) {
        if (res.meta.code == 0) {
          this.articleContent = res.data;
        } else {
          this.$toast(res.meta.message);
        }
      } else {
        this.$toast('操作失败');
      }
    },

  },
}
</script>

<style lang="less" scoped>
@import './search.less';
.details-padding {
  padding: 42px;
  .detail-title {
    width: 100%;
    text-align: center;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 28px;
    color: #1e232a;
  }
  .articleContent {
    padding-top: 20px;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 18px;
    color: #1e232a;
  }
  .detail-timess {
    width: 100%;
    display: flex;
    padding-top: 14px;
    div {
      flex: 1;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
    .numbers {
      text-align: right;
    }
  }
}
::v-deep.your-class {
  object-fit: cover; /* 保持图片比例 */
  height: 100px !important;
}
</style>


